import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../services/api";
import {
  Container, Row, Col, Card, CardBody, Button, Label, Input, Form, FormFeedback,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import AccountHomeButton from "../pages/Auth/account-home-button";

const BusinessLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("bg-account-pages", "py-4", "py-sm-0");
    document.getElementById("colorTheme").setAttribute("href", "assets/colors/red.css");
    return () => {
      document.body.classList.remove("bg-account-pages", "py-4", "py-sm-0");
      document.getElementById("colorTheme").setAttribute("href", "assets/colors/cyan.css");
    };
  }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { email: "", password: "" },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Please Enter Your Email"),
      password: Yup.string().min(6, "Password must be at least 6 characters").required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      try {
        const { data } = await api.post("/business-login", values);
        if (data.accessToken) {
          api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
          alert("Logged in successfully!");
          // Route where business users land (adjust if you have a different dashboard)
          navigate("/bus-dashboard/business/user/profile");
        } else {
          alert(data.message);
          navigate("/business-otp", { state: { businessUserId: data.businessUserId } });
        }
      } catch (err) {
        alert(typeof err?.response?.data === "string" ? err.response.data : "Login failed.");
      }
    },
  });

  return (
    <React.Fragment>
      <AccountHomeButton />
      <section className="vh-100">
        <div className="display-table">
          <div className="display-table-cell">
            <Container>
              <Row className="justify-content-center">
                <Col lg="5">
                  <Card className="account-card">
                    <CardBody>
                      <div className="text-center mt-3">
                        <h3 className="font-weight-bold">
                          <Link to="/" className="text-dark text-uppercase account-pages-logo">
                            <i className="mdi"></i> PAYWEEK
                          </Link>
                        </h3>
                        <p className="text-muted">Business User Sign in.</p>
                      </div>
                      <div className="p-4">
                        <Form onSubmit={validation.handleSubmit}>
                          <div className="form-group">
                            <Label for="email">Email</Label>
                            <Input
                              name="email"
                              placeholder="Enter Email"
                              type="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={validation.touched.email && !!validation.errors.email}
                            />
                            {validation.touched.email && validation.errors.email ? (
                              <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="form-group mt-3">
                            <Label for="password">Password</Label>
                            <Input
                              name="password"
                              placeholder="Enter password"
                              type="password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.password || ""}
                              invalid={validation.touched.password && !!validation.errors.password}
                            />
                            {validation.touched.password && validation.errors.password ? (
                              <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="custom-control custom-checkbox mt-2">
                            <Input type="checkbox" className="custom-control-input" id="rememberMeBU" />{" "}
                            <Label className="custom-control-label" for="rememberMeBU">
                              &nbsp;Remember me
                            </Label>
                          </div>

                          <div className="d-grid mt-3">
                            <Button type="submit" className="btn btn-primary">
                              Log In
                            </Button>
                          </div>

                          <div className="mt-4 mb-0 text-center">
                            <Link to="/forgotpassword" className="text-dark">
                              <i className="mdi mdi-lock"></i> Forgot your password?
                            </Link>
                          </div>
                        </Form>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default BusinessLogin;
